/* eslint-disable max-depth */
import { injectable } from 'inversify';

import type { FlowTreeNode, LinearFlowNode } from '@vk-hr-tek/ui/FlowTree/flow';

import { EventFlow } from '@app/gen/events';

import { EventsFlowMapper } from '../../types';

import { EventsFlowCommonMapper } from './events.flow-common.mapper';
import { EventsFlowMapper as EventsFlowTreeMapper } from './events.flow.mapper.worker';
import { EventsLinearFlowMapper } from './events.linear-flow.mapper';

const commonMapper = new EventsFlowCommonMapper();
const flowMapper = new EventsFlowTreeMapper(commonMapper);
const linearMapper = new EventsLinearFlowMapper(commonMapper);

@injectable()
export class EventsThreadFlowMapper implements EventsFlowMapper {
  async convertTree(flow: EventFlow): Promise<FlowTreeNode> {
    flowMapper.init(flow.nodes, flow.in_paper);

    const result = flowMapper.getFlowTree(flow.start_node_id);

    return result as FlowTreeNode;
  }

  async convertLinear(flow: EventFlow): Promise<LinearFlowNode[]> {
    linearMapper.init(flow.nodes);

    const result = linearMapper.getLinearFlowTree(flow.start_node_id);

    return result;
  }
}
